<div class="modal fade modal-full-width" #modal>
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Atualizar Central de Compras
                </h4>
            </div>
            <div class="modal-body">
                <sgt-cliente-central-compra-form
                    #form>                    
                </sgt-cliente-central-compra-form>
            </div>
            <div class="modal-footer">           
                <button type="button" class="btn btn-light" (click)="cancel()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-success" id="btnSaveCentralCompra" (click)="save()">
                    Salvar
                </button>                
            </div>            
        </div>
    </div>
</div>